import * as Types from '../../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type GetLocationOverheadRateQueryVariables = Types.Exact<{
  siteLocationId: Types.Scalars['String']['input'];
}>;


export type GetLocationOverheadRateQuery = { __typename?: 'Query', locationOverheadRate?: { __typename?: 'LocationOverheadRateDocument', id: string, siteLocationId: string, subLocationId?: string | null, costPerSqFtPerWeek: number, effectiveFrom: Types.TDateISO, effectiveTo?: Types.TDateISO | null, updated: Types.TDateISO } | null };

export type LocationOverheadRateFieldsFragment = { __typename?: 'LocationOverheadRateDocument', id: string, siteLocationId: string, subLocationId?: string | null, costPerSqFtPerWeek: number, effectiveFrom: Types.TDateISO, effectiveTo?: Types.TDateISO | null, updated: Types.TDateISO };

export type GetLocationOverheadRatesQueryVariables = Types.Exact<{
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  where?: Types.InputMaybe<Types.LocationOverheadRateDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.LocationOverheadRateDocumentSortInput> | Types.LocationOverheadRateDocumentSortInput>;
  includeDeactivated?: Types.Scalars['Boolean']['input'];
}>;


export type GetLocationOverheadRatesQuery = { __typename?: 'Query', locationOverheadRates?: { __typename?: 'LocationOverheadRatesConnection', totalCount: number, nodes?: Array<{ __typename?: 'LocationOverheadRateDocument', id: string, siteLocationId: string, subLocationId?: string | null, costPerSqFtPerWeek: number, effectiveFrom: Types.TDateISO, effectiveTo?: Types.TDateISO | null, updated: Types.TDateISO }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetLocationOverheadRateCountQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.LocationOverheadRateDocumentFilterInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  includeDeactivated?: Types.Scalars['Boolean']['input'];
}>;


export type GetLocationOverheadRateCountQuery = { __typename?: 'Query', locationOverheadRates?: { __typename?: 'LocationOverheadRatesConnection', totalCount: number } | null };

export type LaborRateFieldsFragment = { __typename?: 'LaborRateDocument', id: string, siteLocationId: string, laborTypeId: string, tenantId: string, ratePerHour: number, effectiveFrom: Types.TDateISO, effectiveTo?: Types.TDateISO | null, updated: Types.TDateISO };

export type GetLaborActiveRatesQueryVariables = Types.Exact<{
  siteLocationId: Types.Scalars['String']['input'];
  asOf?: Types.InputMaybe<Types.Scalars['DateTime']['input']>;
}>;


export type GetLaborActiveRatesQuery = { __typename?: 'Query', laborActiveRates: Array<{ __typename?: 'LaborRateDocument', id: string, siteLocationId: string, laborTypeId: string, tenantId: string, ratePerHour: number, effectiveFrom: Types.TDateISO, effectiveTo?: Types.TDateISO | null, updated: Types.TDateISO }> };

export type GetLaborRateHistoryQueryVariables = Types.Exact<{
  includeDeactivated?: Types.Scalars['Boolean']['input'];
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  where?: Types.InputMaybe<Types.LaborRateDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.LaborRateDocumentSortInput> | Types.LaborRateDocumentSortInput>;
}>;


export type GetLaborRateHistoryQuery = { __typename?: 'Query', laborRates?: { __typename?: 'LaborRatesConnection', totalCount: number, nodes?: Array<{ __typename?: 'LaborRateDocument', id: string, siteLocationId: string, laborTypeId: string, tenantId: string, ratePerHour: number, effectiveFrom: Types.TDateISO, effectiveTo?: Types.TDateISO | null, updated: Types.TDateISO }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetLaborRateCountQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.LaborRateDocumentFilterInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  includeDeactivated?: Types.Scalars['Boolean']['input'];
}>;


export type GetLaborRateCountQuery = { __typename?: 'Query', laborRates?: { __typename?: 'LaborRatesConnection', totalCount: number } | null };

export type CalculateProductionJobCostsQueryVariables = Types.Exact<{
  productionJobIds: Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input'];
}>;


export type CalculateProductionJobCostsQuery = { __typename?: 'Query', calculateProductionJobCosts: Array<{ __typename?: 'ProductionJobCostResult', productionJobId: string, productionRecipeId: string, productionRecipeVariationId?: string | null, siteLocationId?: string | null, quantity: number, costingQuantity: number, materialsCost: number, materialsCostPerUnit: number, supplierRoyaltyCost: number, supplierRoyaltyCostPerUnit: number, supplierRoyaltyCoverage: Types.SupplierRoyaltyCoverage, laborCost: number, laborCostPerUnit: number, overheadCost: number, overheadCostPerUnit: number, additionalCost: number, additionalCostPerUnit: number, directCost: number, directCostPerUnit: number, totalCost: number, totalCostPerUnit: number, computedTotalCost: number, computedTotalCostPerUnit: number, costSource: Types.RecipeCostSource, isComplete: boolean, incompleteCostReasons: Array<string>, overallStatus: Types.CostCalcStepSeverity, materialEvents: Array<{ __typename?: 'CostEventResult', name: string, sourceId: string, sourceType: string, perUnitCost: number, detail?: string | null }>, supplierRoyaltyEvents: Array<{ __typename?: 'CostEventResult', name: string, sourceId: string, sourceType: string, perUnitCost: number, detail?: string | null }>, laborEvents: Array<{ __typename?: 'CostEventResult', name: string, sourceId: string, sourceType: string, perUnitCost: number, detail?: string | null }>, overheadEvents: Array<{ __typename?: 'CostEventResult', name: string, sourceId: string, sourceType: string, perUnitCost: number, detail?: string | null }>, calcSteps: Array<{ __typename?: 'CostCalcStep', code: string, message: string, severity: Types.CostCalcStepSeverity, context: Array<{ __typename?: 'CostCalcStepContextEntry', entityId?: string | null, entityType?: string | null, key: string, value: string }> }> }> };

export const LocationOverheadRateFieldsFragmentDoc = new TypedDocumentString(`
    fragment LocationOverheadRateFields on LocationOverheadRateDocument {
  id
  siteLocationId
  subLocationId
  costPerSqFtPerWeek
  effectiveFrom
  effectiveTo
  updated
}
    `, {"fragmentName":"LocationOverheadRateFields"});
export const LaborRateFieldsFragmentDoc = new TypedDocumentString(`
    fragment LaborRateFields on LaborRateDocument {
  id
  siteLocationId
  laborTypeId
  tenantId
  ratePerHour
  effectiveFrom
  effectiveTo
  updated
}
    `, {"fragmentName":"LaborRateFields"});
export const GetLocationOverheadRateDocument = new TypedDocumentString(`
    query GetLocationOverheadRate($siteLocationId: String!) {
  locationOverheadRate(siteLocationId: $siteLocationId) {
    ...LocationOverheadRateFields
  }
}
    fragment LocationOverheadRateFields on LocationOverheadRateDocument {
  id
  siteLocationId
  subLocationId
  costPerSqFtPerWeek
  effectiveFrom
  effectiveTo
  updated
}`);
export const GetLocationOverheadRatesDocument = new TypedDocumentString(`
    query GetLocationOverheadRates($first: Int, $after: String, $where: LocationOverheadRateDocumentFilterInput, $order: [LocationOverheadRateDocumentSortInput!], $includeDeactivated: Boolean! = false) {
  locationOverheadRates(
    first: $first
    after: $after
    where: $where
    order: $order
    includeDeactivated: $includeDeactivated
  ) {
    nodes {
      ...LocationOverheadRateFields
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment LocationOverheadRateFields on LocationOverheadRateDocument {
  id
  siteLocationId
  subLocationId
  costPerSqFtPerWeek
  effectiveFrom
  effectiveTo
  updated
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetLocationOverheadRateCountDocument = new TypedDocumentString(`
    query GetLocationOverheadRateCount($where: LocationOverheadRateDocumentFilterInput, $first: Int, $includeDeactivated: Boolean! = false) {
  locationOverheadRates(
    first: $first
    where: $where
    includeDeactivated: $includeDeactivated
  ) {
    totalCount
  }
}
    `);
export const GetLaborActiveRatesDocument = new TypedDocumentString(`
    query GetLaborActiveRates($siteLocationId: String!, $asOf: DateTime) {
  laborActiveRates(siteLocationId: $siteLocationId, asOf: $asOf) {
    ...LaborRateFields
  }
}
    fragment LaborRateFields on LaborRateDocument {
  id
  siteLocationId
  laborTypeId
  tenantId
  ratePerHour
  effectiveFrom
  effectiveTo
  updated
}`);
export const GetLaborRateHistoryDocument = new TypedDocumentString(`
    query GetLaborRateHistory($includeDeactivated: Boolean! = false, $first: Int, $after: String, $where: LaborRateDocumentFilterInput, $order: [LaborRateDocumentSortInput!]) {
  laborRates(
    first: $first
    after: $after
    where: $where
    order: $order
    includeDeactivated: $includeDeactivated
  ) {
    nodes {
      ...LaborRateFields
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment LaborRateFields on LaborRateDocument {
  id
  siteLocationId
  laborTypeId
  tenantId
  ratePerHour
  effectiveFrom
  effectiveTo
  updated
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetLaborRateCountDocument = new TypedDocumentString(`
    query GetLaborRateCount($where: LaborRateDocumentFilterInput, $first: Int, $includeDeactivated: Boolean! = false) {
  laborRates(
    first: $first
    where: $where
    includeDeactivated: $includeDeactivated
  ) {
    totalCount
  }
}
    `);
export const CalculateProductionJobCostsDocument = new TypedDocumentString(`
    query CalculateProductionJobCosts($productionJobIds: [String!]!) {
  calculateProductionJobCosts(productionJobIds: $productionJobIds) {
    productionJobId
    productionRecipeId
    productionRecipeVariationId
    siteLocationId
    quantity
    costingQuantity
    materialsCost
    materialsCostPerUnit
    supplierRoyaltyCost
    supplierRoyaltyCostPerUnit
    supplierRoyaltyCoverage
    laborCost
    laborCostPerUnit
    overheadCost
    overheadCostPerUnit
    additionalCost
    additionalCostPerUnit
    directCost
    directCostPerUnit
    totalCost
    totalCostPerUnit
    computedTotalCost
    computedTotalCostPerUnit
    costSource
    isComplete
    incompleteCostReasons
    materialEvents {
      name
      sourceId
      sourceType
      perUnitCost
      detail
    }
    supplierRoyaltyEvents {
      name
      sourceId
      sourceType
      perUnitCost
      detail
    }
    laborEvents {
      name
      sourceId
      sourceType
      perUnitCost
      detail
    }
    overheadEvents {
      name
      sourceId
      sourceType
      perUnitCost
      detail
    }
    calcSteps {
      code
      context {
        entityId
        entityType
        key
        value
      }
      message
      severity
    }
    overallStatus
  }
}
    `);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetLocationOverheadRate: build.query<GetLocationOverheadRateQuery, GetLocationOverheadRateQueryVariables>({
      query: (variables) => ({ document: GetLocationOverheadRateDocument, variables })
    }),
    GetLocationOverheadRates: build.query<GetLocationOverheadRatesQuery, GetLocationOverheadRatesQueryVariables | void>({
      query: (variables) => ({ document: GetLocationOverheadRatesDocument, variables })
    }),
    GetLocationOverheadRateCount: build.query<GetLocationOverheadRateCountQuery, GetLocationOverheadRateCountQueryVariables | void>({
      query: (variables) => ({ document: GetLocationOverheadRateCountDocument, variables })
    }),
    GetLaborActiveRates: build.query<GetLaborActiveRatesQuery, GetLaborActiveRatesQueryVariables>({
      query: (variables) => ({ document: GetLaborActiveRatesDocument, variables })
    }),
    GetLaborRateHistory: build.query<GetLaborRateHistoryQuery, GetLaborRateHistoryQueryVariables | void>({
      query: (variables) => ({ document: GetLaborRateHistoryDocument, variables })
    }),
    GetLaborRateCount: build.query<GetLaborRateCountQuery, GetLaborRateCountQueryVariables | void>({
      query: (variables) => ({ document: GetLaborRateCountDocument, variables })
    }),
    CalculateProductionJobCosts: build.query<CalculateProductionJobCostsQuery, CalculateProductionJobCostsQueryVariables>({
      query: (variables) => ({ document: CalculateProductionJobCostsDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetLocationOverheadRateQuery, useLazyGetLocationOverheadRateQuery, useGetLocationOverheadRatesQuery, useLazyGetLocationOverheadRatesQuery, useGetLocationOverheadRateCountQuery, useLazyGetLocationOverheadRateCountQuery, useGetLaborActiveRatesQuery, useLazyGetLaborActiveRatesQuery, useGetLaborRateHistoryQuery, useLazyGetLaborRateHistoryQuery, useGetLaborRateCountQuery, useLazyGetLaborRateCountQuery, useCalculateProductionJobCostsQuery, useLazyCalculateProductionJobCostsQuery } = injectedRtkApi;
